<template>
  <div class="MainDiv" v-bind:class="{ 'heightAuto': !autoCompleteVisible, 'height300' : autoCompleteVisible}">
    <div class="container-fluid ">
		  <div class="row margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-xs-8 col-sm-3 col-md-3 col-lg-2 margin-top-3px font-size-18px padding-left-1Point8Perc">
          ASSESSMENT
        </div>
        <div class="col-xs-8 col-sm-6 col-md-4 col-lg-4 padding-left-0Perc">
          <div class="form-group margin-bottom-0Perc">
            <div class="icon-addon addon-lg">
              <input type="text" ref="input" class="form-control background-gray border-rounded" autocomplete="off" id="search" v-on:focus="increaseComponentHeight($event)" v-on:blur="decreaseComponentHeight($event)"/>
              <label class="glyphicon glyphicon-search"></label>
              <typeahead v-model="selectedAssessmentObj" target="#search" :data="assessments" id="typeheadSearch" item-key="AssessmentTitle" :limit="20" append-to-body :open-on-empty="true"></typeahead>
            </div>
          </div>
        </div>
        <div class="col-xs-3 col-sm-2 col-md-1 col-lg-1 padding-left-0Perc text-align-center">  
          <button type="button" class="btn black-border custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-12" v-on:click="showAssessmentList">Go</button>
        </div>
        <div class="col-xs-4 col-sm-1 col-md-2 col-lg-1 left-border padding-top-32px margin-top-Point1Perc width-0Perc padding-left-0Perc padding-right-0Perc" v-if="false"></div>
        <div class="col-xs-8 col-sm-3 col-md-2 col-lg-2">
          <button type="button" class="btn black-border custom-btn white-BG col-xs-12 col-sm-12 col-md-12 col-lg-9" v-on:click="openCreateAssessmentOverlay($event)" v-if="false">+ Create New</button>
        </div>
      </div>
      <create-assessment-overlay v-if="!hideCreateAssessmentOverlay" :comingFrom="isComingFrom" @closeOverlay="updateHideCreateAssessmentOverlayFlag" @showSpinner='updateShowSpinnerFlag'></create-assessment-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
  </div>  
</div>
</template>

<script>
import CreateAssessmentOverlay from '@/components/assessments/CreateAssessmentOverlay'
import { constants } from '@/utils/constants'
import { assessmentService } from '@/server-util/assessment-service'
import { Typeahead } from 'uiv'
import Autocomplete from 'vuejs-auto-complete'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { isObject } from 'lodash'
export default {
  props: ['newlyCreatedAssessmentObj'],
  created: function () {
    this.openSelectedAssessment()
  },
  data: function () {
    return {
      isComingFrom: 'assessment_journey',
      hideCreateAssessmentOverlay: true,
      clickedCreateAssessment: true,
      selectedAssessmentObj: null,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      autoCompleteVisible: false,
      assessmentId: ''
    }
  },
  methods: {
    openCreateAssessmentOverlay: function (event) {
      this.hideCreateAssessmentOverlay = false
      this.$store.state.isOverlayVisible = true
    },
    updateHideCreateAssessmentOverlayFlag (newValue) {
      // AK: If user pressed X and after Creating Successfully Assessment
      this.hideCreateAssessmentOverlay = newValue
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = false
    },
    openSelectedAssessment: function () {
      // AK: If user coming from manange course page then show selected course
      this.assessmentId = this.$route.query.assessmentId
      // console.log('this.assessmentId >>> ' + this.assessmentId)
      if (this.assessmentId !== undefined) {
        for (var i = 0; i < this.$store.state.assessmentList.length; i++) {
          // console.log('this.$store.state.assessmentList[i] ' + JSON.stringify(this.$store.state.assessmentList[i]))
          if (this.$store.state.assessmentList[i].AssessmentId === this.assessmentId) {
            this.selectedAssessmentObj = this.$store.state.assessmentList[i]
          }
        }
        // console.log('this.selectedAssessmentObj From URL>>> ' + JSON.stringify(this.selectedAssessmentObj))
        this.getAssessmentElments()
        this.$store.state.hightLightOptionExplictly = true
        setTimeout(() => {
          this.$store.state.hightLightOptionExplictly = false
        }, 500)
      }
    },
    updateClickedCreateAssessment: function () {
      this.$emit('clickedCreateAssessment', this.clickedCreateAssessment)
    },
    showAssessmentList: function () {
      if (this.selectedAssessmentObj !== undefined && this.selectedAssessmentObj !== 'undefined' && this.selectedAssessmentObj !== null && this.selectedAssessmentObj !== 'null' && this.selectedAssessmentObj !== '' && isObject(this.selectedAssessmentObj)) {
        this.getAssessmentElments()
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid assessment.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssessmentElments () {
      if (this.selectedAssessmentObj !== undefined && this.selectedAssessmentObj !== 'undefined' && this.selectedAssessmentObj !== null && this.selectedAssessmentObj !== 'null' && this.selectedAssessmentObj !== '' && isObject(this.selectedAssessmentObj)) {
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        assessmentService
          .getAllAssessmentElementList(
            storeObj.state.access_token,
            this.selectedAssessmentObj.AssessmentId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.selectedAssessmentElementList = responseObj.data
              this.$store.state.selectedAssessmentObjFromFilter = this.selectedAssessmentObj
              this.$emit('checkAndShowAssessmentList', true)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            _this.$store.state.isLoading = false
          }, errorObj => {
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid assessment.'
      }
    },
    increaseComponentHeight: function (evt) {
      console.log('DATA LOADED FOR TYPEHEADE : ')
      this.autoCompleteVisible = true
    },
    decreaseComponentHeight: function (evt) {
      this.autoCompleteVisible = false
    },
    updateShowSpinnerFlag (value) {
      this.$store.state.isLoading = value
    }
  },
  computed: {
    assessments () {
      return this.$store.state.assessmentList
    }
  },
  components: {
    Typeahead,
    Autocomplete,
    'alert-box': AlertBox,
    'loader': Loader,
    'create-assessment-overlay': CreateAssessmentOverlay
  },
  watch: {
    newlyCreatedAssessmentObj: function (newVal, oldVal) {
      // console.log('newlyCreatedAssessmentObj >>> ' + JSON.stringify(newVal))
      if (newVal !== null) {
        this.selectedAssessmentObj = newVal
        this.getAssessmentElments()
      }
    },
    $route (to, from) {
      this.openSelectedAssessment()
    }
  },
  name: 'MainDiv'
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.margin-Right-2Point4Perc {
  margin-right: 2.4% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}
.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}
.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  /* padding: 10px 16px 10px 40px; */
  padding: 7px 16px 6px 40px;
}
.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}
.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}
.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}
.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}
.cart {
  width: 600px;
}
.checkout-table {
  width: 100%;
}
.checkout-table th {
  text-align: left;
  padding: 15px 0px;
  border-bottom: 1px solid #aaa;
}
.checkout-table td {
  padding: 8px 0px;
}
.checkout-button {
  float: right;
  width: 120px;
  height: 40px;
  margin-top: 20px;
}
.total td {
  border-top: 1px solid #aaa;
  padding-top: 10px;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-18px {
  font-size: 18px;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
 /* #typeheadSearch.dropdown{
  position: relative ;
}  */
.height300{
  /* height: 330px; */
  height: 630px;
  overflow-y: scroll;
}
heightAuto{
  height: auto;
}
.dropdown {
  position: static !important;
  /* display:none!important; */
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-top-3px{
  margin-top: 3px !important;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc{
  margin-right: 1%;
}
.padding-right-0Perc{
  padding-right:0%;
}
.padding-right-1Perc{
  padding-right:1%;
}
.width-14Perc{
  width:14%;
}
.margin-left-1Point6Perc{
  margin-left:1.6%;
}
.width-15Perc{
  width:15% !important;
}
.margin-left2Point8Perc{
  margin-left:2.8% !important;
}
.padding-left-2Point4Perc{
  padding-left:2.4%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.padding-left-4Point5Perc{
  padding-left:4.5%;
}
.padding-left-2Perc{
  padding-left:2%;
}
.width-7Perc{
  width:7%;
}
.margin-bottom-0Perc{
  margin-bottom: 0%;
}
.padding-left-10Perc{
  padding-left: 10%;
}
.padding-1Point4Perc{
  padding: 1.4%;
}
.width-0Perc{
  width:0%;
}
.padding-top-32px{
  padding-top:32px;
}
.margin-top-Point1Perc{
  margin-top:.1%;
}
.padding-left-5px{
  padding-left:5px;
}
.padding-left-1Point8Perc{
  padding-left:1.8%;
}
</style>





// WEBPACK FOOTER //
// src/components/assessment_journey/AssessmentSearchBar.vue